/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentPriority } from './AssignmentPriority';
import {
    AssignmentPriorityFromJSON,
    AssignmentPriorityFromJSONTyped,
    AssignmentPriorityToJSON,
    AssignmentPriorityToJSONTyped,
} from './AssignmentPriority';

/**
 * 
 * @export
 * @interface CreateAssignmentRequest
 */
export interface CreateAssignmentRequest {
    /**
     * 
     * @type {AssignmentPriority}
     * @memberof CreateAssignmentRequest
     */
    priority: AssignmentPriority;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateAssignmentRequest
     */
    dueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    assignedCounselorId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    assignedClientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssignmentRequest
     */
    assignedCaseNoteId?: string | null;
}



/**
 * Check if a given object implements the CreateAssignmentRequest interface.
 */
export function instanceOfCreateAssignmentRequest(value: object): value is CreateAssignmentRequest {
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('assignedClientId' in value) || value['assignedClientId'] === undefined) return false;
    return true;
}

export function CreateAssignmentRequestFromJSON(json: any): CreateAssignmentRequest {
    return CreateAssignmentRequestFromJSONTyped(json, false);
}

export function CreateAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'priority': AssignmentPriorityFromJSON(json['priority']),
        'description': json['description'],
        'dueDate': (new Date(json['dueDate'])),
        'assignedCounselorId': json['assignedCounselorId'],
        'assignedClientId': json['assignedClientId'],
        'assignedCaseNoteId': json['assignedCaseNoteId'] == null ? undefined : json['assignedCaseNoteId'],
    };
}

export function CreateAssignmentRequestToJSON(json: any): CreateAssignmentRequest {
    return CreateAssignmentRequestToJSONTyped(json, false);
}

export function CreateAssignmentRequestToJSONTyped(value?: CreateAssignmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priority': AssignmentPriorityToJSON(value['priority']),
        'description': value['description'],
        'dueDate': value['dueDate'].toISOString(),
        'assignedCounselorId': value['assignedCounselorId'],
        'assignedClientId': value['assignedClientId'],
        'assignedCaseNoteId': value['assignedCaseNoteId'],
    };
}

